import { render, staticRenderFns } from "./BellAuthEdit.vue?vue&type=template&id=78fa21ac&scoped=true"
import script from "./BellAuthEdit.vue?vue&type=script&lang=js"
export * from "./BellAuthEdit.vue?vue&type=script&lang=js"
import style0 from "./BellAuthEdit.vue?vue&type=style&index=0&id=78fa21ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa21ac",
  null
  
)

export default component.exports